import axios from 'axios';
import { auth } from '../firebase';
import { callApi } from './useApi';

let cachedHubToken = null;
let cachedHubTokenExpiresAt = 0;

/**
 * Retorna a URL base correta da API do Hub dependendo do ambiente e hostname.
 * Em produção ou domínios remotos (ex: app.duzzsystem.com.br), aponta automaticamente para a API no Cloud Run.
 */
export function getHubApiUrl() {
  if (process.env.REACT_APP_HUB_API_URL) {
    return process.env.REACT_APP_HUB_API_URL;
  }
  const isLocal = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );
  return isLocal
    ? 'http://localhost:8000'
    : 'https://checkout-duzz-api-500930429533.us-central1.run.app';
}

/**
 * Resolve os headers de autorização para chamadas à API do Hub.
 * - Usuário autenticado no Firebase: utiliza o Firebase ID Token (Bearer <jwt>).
 * - Usuário operador do Duzz Comercial: gera um token Fernet assinado criptograficamente
 *   através da API do backend principal (POST /auth/hub-token) e o envia como Bearer token.
 */
export async function getHubAuthHeaders(credencials, activeUser = null) {
  const headers = {};

  let user = activeUser || auth.currentUser;

  // Se o usuário ainda não estiver pronto (ex: logo após recarregar a página), aguarda a resolução do Firebase Auth
  if (!user && auth && typeof auth.authStateReady === 'function') {
    try {
      await auth.authStateReady();
      user = auth.currentUser;
    } catch (e) {
      console.warn('[getHubAuthHeaders] Erro ao aguardar authStateReady:', e);
    }
  }

  // 1. Usuário autenticado diretamente no Firebase
  if (user) {
    try {
      const token = await user.getIdToken();
      headers.Authorization = `Bearer ${token}`;
      return headers;
    } catch (e) {
      console.warn('[getHubAuthHeaders] Erro ao obter Firebase ID token:', e);
    }
  }

  // 2. Operador autenticado com credenciais do Duzz Comercial
  if (credencials?.sessionToken && credencials?.company) {
    const now = Date.now();
    if (
      cachedHubToken &&
      cachedHubToken.company === credencials.company &&
      cachedHubToken.sessionToken === credencials.sessionToken &&
      now < cachedHubTokenExpiresAt
    ) {
      headers.Authorization = `Bearer ${cachedHubToken.token}`;
      return headers;
    }

    try {
      const response = await callApi(
        {
          method: 'post',
          url: '/auth/hub-token',
        },
        credencials
      );

      const token = response?.data?.token || response?.data?.hubToken;
      if (token) {
        cachedHubToken = {
          token,
          company: credencials.company,
          sessionToken: credencials.sessionToken,
        };
        cachedHubTokenExpiresAt = now + 240 * 1000; // Cache de 4 minutos
        headers.Authorization = `Bearer ${token}`;
        return headers;
      }
    } catch (err) {
      console.error('[getHubAuthHeaders] Falha ao gerar token assinado do Hub no backend principal:', err);
    }
  }

  return headers;
}
